import {p0, p1, p16, p2, p4, p8, p32} from "../../pl_commons";
import React from "react";

const basestroke = '#000000'
const greystroke = '#7c7c7c'

export function baseline(avail) {
    if( avail === undefined) {
        avail = true
    }
    const stroke= avail ? basestroke : greystroke
    return (
        <line key="l1" x1={p0} y1={p2} x2={p1} y2={p2} strokeWidth={p8} stroke={stroke}
              strokeLinecap="butt"/>
    )
}

export function baseline_turn(avail) {
    if( avail === undefined) {
        avail = true
    }
    let stroke= avail ? basestroke : greystroke

    return (
        <line key="k3" x1={p0} y1={p2} x2={p2 + p16} y2={p0 - p16} strokeWidth={p8} stroke={stroke}
              strokeLinecap="butt"/>
    )
}

export function baseline_turn2(avail) {
    if( avail === undefined) {
        avail = true
    }
    let stroke= avail ? basestroke : greystroke

    return (
        <line key="k47z" x1={p2} y1={p1} x2={p1} y2={p2} strokeWidth={p8} stroke={stroke}
              strokeLinecap="butt"/>
    )
}

export function bm_right({avail, stroke, animate}) {
    if( avail === undefined) {
        avail = true
    }
    const _stroke= avail ? stroke : greystroke
    return(
        <line key="l3" x1={p2 + p8} y1={p2} x2={p1 - p8} y2={p2} strokeWidth={p16} stroke={_stroke}
              strokeLinecap="butt">{animate}</line>
    )
}

export function bm_left({avail, stroke, animate}) {
    if( avail === undefined) {
        avail = true
    }
    const _stroke= avail ? stroke : greystroke
    return (
        <line key="l2" x1={p8} y1={p2} x2={p2 - p8} y2={p2} strokeWidth={p16} stroke={_stroke}
              strokeLinecap="butt">{animate}</line>
    )
}

export function bm_turn({avail, stroke, animate}) {
    if( avail === undefined) {
        avail = true
    }
    const _stroke= avail ? stroke : greystroke
    return (
        <line key="k4" x1={p2 - p8 + p16} y1={p8 - p16} x2={p2 - p4 - p16} y2={p2 - p4 + p16}
              strokeWidth={p16 + p16 / 4}
              stroke={_stroke} strokeLinecap="butt">{animate}</line>
    )
}

export function bm_turn2({avail, stroke, animate}) {
    if( avail === undefined) {
        avail = true
    }
    const _stroke= avail ? stroke : greystroke
    return (
        <line key="k4x" x1={p1 - p8 + p16} y1={p2 + p8 - p16} x2={p1 - p4 - p16} y2={p1 - p4 + p16}
              strokeWidth={p16 + p16 / 4}
              stroke={_stroke} strokeLinecap="butt">{animate}</line>
    )
}
